import { v5 as uuidv5 } from 'uuid';

// From RFC-4122. See: https://www.rfc-editor.org/rfc/rfc4122#appendix-C
const OID_NAMESPACE = '6ba7b812-9dad-11d1-80b4-00c04fd430c8';

export const hash = (input: string): string => {
  return uuidv5(input, OID_NAMESPACE);
};
